(function () {
    'use strict';

    angular.module("imApp").factory("deliveryMethodsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2171,
                    parameters: parms || {}
                });
            },
            listDeliveryMethods: function (parms) {
                return $ihttp.post({
                    method: 385,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
